// extracted by mini-css-extract-plugin
module.exports = {"botaoLupa":"InputConsultar_botaoLupa__1lC_e"};